import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore} from 'angularfire2/firestore'
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import { Idioma } from '../models/idioma';
import { FirebaseApp } from 'angularfire2';
import 'rxjs/add/operator/catch';
import {HttpClient,HttpHeaders} from '@angular/common/http';

@Injectable()
export class UsuariosPersonalService {

  // Contiene el estatus actual del usuaro de la aplicación
  public auth:any = null;
  firebaseStorage:any;

  //Contiene el rol del usuario Actual
  public rol:string = "";

  constructor(
    private firebaseApp:FirebaseApp,
    private afDB: AngularFireDatabase,
    private afAuth: AngularFireAuth,
    private firestore:AngularFirestore,
    private http:Http,
    private httpC:HttpClient) {
        this.firebaseStorage = firebaseApp.storage().ref();
     }

  /**
   * Crea un nuevo usuario
   * @param email
   * @param password
   */
  crearUsuario(email:string, password:string){
    let body = { email , password, returnSecureToken : true }
    let headers = new Headers( { 'Content-Type': 'application/json' } ); // ... Set content type to JSON
    let options = new RequestOptions({ headers });
    return this.http.post('https://www.googleapis.com/identitytoolkit/v3/relyingparty/signupNewUser?key=AIzaSyC8X6Yg0NULOzyG8Z93WKxabJvLix9nPw4', body, options)
    .map((res:Response) => res.json())
    .catch(error => Observable.of(error.json()));
  }

  /**
   * Crear usuario personal
   * @param uid
   */
  public crearPersonal(uid, personal):Promise<any>{
    return this.afDB.object('/usuariosPersonal/' + uid + '/').set(personal);
  }

  // Obtiene todos los usuarios dados de alta en el sistema
  public obtenerUsuariosPersonal(){
    return this.afDB.list('usuariosPersonal');
  }

  /**
   * Obtiene los usuarios de un departamento en específico
   * @param departamento
   */
  public obtenerUsuariosDepartamento(departamento){
    return this.afDB.list('/usuariosPersonal/', ref => ref.orderByChild('informacionLaboral/departamento/').equalTo(departamento));
  }

  // Obtiene todos los operadores del sistema
  public obtenerOperadores(){
    return this.afDB.list('/usuariosPersonal/', ref => ref.orderByChild('informacionDelSistema/rolDeUsuario/').equalTo('Operador'));
  }

  /**
   * Obtiene toda la información de un usuario
   * @param uid
   */
  public obtenerUsuario(uid){
    return this.afDB.object('/usuariosPersonal/' + uid + '/');
  }

  /**
   * Obtiene la propiedad de un usuario
   * @param uid
   * @param propiedad
   */
  public obtenerPropiedadDeUsuario(uid:string, propiedad:string){
    return this.afDB.object('/usuariosPersonal/' + uid + '/' + propiedad);
  }

  /**
   * Cambia el estatus de personal
   * @param uid
   * @param estatus
   */
  public cambiarEstatusDePersonal(uid:string, estatus:string){
    return this.afDB.object('/usuariosPersonal/' + uid + '/informacionLaboral/estatusPersonal/').set(estatus);
  }

  /**
   * Resetea la contraseña de un usuario
   * @param email
   */
  public resetearPassword(email){
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }

    public avisar_request_password(email){
        return this.afAuth.auth.sendPasswordResetEmail(email);
    }

  /**
   * Actualiza la información personal de un usuario
   * @param uid
   */
  public actualizarInformacionPersonal(uid, datos){
    return this.afDB.object('/usuariosPersonal/' + uid + '/informacionPersonal/').update(datos);
  }
   /**
   * Actualiza la información del sistema de un usuario
   * @param uid
   */
  public actualizarInformacionSistema(uid, datos){
    return this.afDB.object('/usuariosPersonal/' + uid + '/informacionDelSistema/').update(datos);
  }
  public crearDatosEspecialesDeOperador(uid, datos){
    return this.afDB.object('/usuariosPersonal/' + uid + '/informacionOperador/').set(datos);
  }

  /**
   * Actualiza la información del domicilio del usuario
   * @param uid
   * @param datos
   */
  public actualizarDomicilio(uid, datos){
    return this.afDB.object('/usuariosPersonal/' + uid + '/domicilio/').update(datos);
  }

  /**
   * Actualiza la información laboral del usuario
   * @param uid
   * @param datos
   */
  public actualizarInformacionLaboral(uid, datos){
    return this.afDB.object('/usuariosPersonal/' + uid + '/informacionLaboral/').update(datos);
  }

  /**
   * Agrega un idioma al usuario
   * @param uid
   * @param idioma
   */
  public agregarIdioma(uid:string, idioma:Idioma){
    return this.afDB.object('/usuariosPersonal/'+ uid  + '/informacionLaboral/idiomas/' + idioma.nombre + '/').set(idioma.porcentaje);
  }

    public agregarCertificacion(uid:string, certificacion){
        return this.afDB.object('/usuariosPersonal/'+ uid  + '/informacionLaboral/certificaciones/' + certificacion.id_ruta + '/').set(certificacion.version);
    }

    public agregarSupervisado(uid:string, supervisado){
        return this.afDB.object('/usuariosPersonal/'+ uid  + '/informacionLaboral/supervisados/' + supervisado.key_operador + '/').set(supervisado.nombre);
    }
  /**
   * Eliminar el idioma a un usuario
   * @param uid
   * @param idioma
   */
  public eliminarIdioma(uid:string, idioma:Idioma){
    return this.afDB.object('/usuariosPersonal/'+ uid  + '/informacionLaboral/idiomas/' + idioma.nombre + '/').remove();
  }

    public eliminarCertificacion(uid:string, certificacion){
        return this.afDB.object('/usuariosPersonal/'+ uid  + '/informacionLaboral/certificaciones/' +  certificacion.id_ruta  + '/').remove();
    }

    public eliminarSupervisado(uid:string, supervisado){
        return this.afDB.object('/usuariosPersonal/'+ uid  + '/informacionLaboral/supervisados/' +  supervisado  + '/').remove();
    }

   /**
   * Reemplaza la fotografia del personal seleccionado
   * @param uid
   * @param foto
   */
  public actualizarFotografiaPersonal(uid, foto){
    return this.firebaseStorage.child('fotografias-personal/'+ uid+'/'+uid+'.jpg').put(foto).then((img)=>{
        return this.afDB.object('usuariosPersonal/'+uid+'/informacionLaboral/').update({fotografia: img.downloadURL})
    })
  }

  public getUltimaVersion()
  {
      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
      const body = '';
      return this.httpC.post('https://operacion.trosten.com/corp-school/php/admin/Version/getVersionSistemaVentas.php', body,{headers});
  }

  public actualizarDiaDescansoOperador (key,dia)
  {
      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

      const body = 'operador_key=' + key +
          '&dia='+dia;

      return this.httpC.post('https://operacion.trosten.com/corp-school/php/admin/DiasDescanso/editarDiaDescansoByOperadorKey.php', body,{headers});
  }

    public actualizarEstatusDiaDescansoOperador (key,estatus)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'operador_key=' + key +
            '&estatus='+estatus;

        return this.httpC.post('https://operacion.trosten.com/corp-school/php/admin/DiasDescanso/editarEstatusDiaDescansoByOperadorKey.php', body,{headers});
    }
    public liberarRutasCorpDeOperadorDadoDeBaja (key)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'operador_key=' + key;

        return this.httpC.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/liberarRutasCorpDeOperadorDadoDeBaja.php', body,{headers});
    }
    
    public agregarDiaDescanso (key,dia,nombre)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'operador_key=' + key +
            '&dia='+
            '&nombre='+nombre;

        return this.httpC.post('https://operacion.trosten.com/corp-school/php/admin/DiasDescanso/agregarDiaDescanso.php', body,{headers});
    }



}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/usuarios-personal.service.ts